module.exports = __webpack_public_path__ + "static/media/marker.547320f2.png";